import {Model} from "../base/Model";


export class AddressModel extends Model  {
key: string;
address: string = "";
zipcode: string = "";
residence: string = "";

    constructor(data = null) {
        super();
        if(data) {
            this.createModel(data);
        }
    }      
}